import { render, staticRenderFns } from "./BarChartDisplay.html?vue&type=template&id=39e285f1&scoped=true&"
import script from "./BarChartDisplay.js?vue&type=script&lang=js&"
export * from "./BarChartDisplay.js?vue&type=script&lang=js&"
import style0 from "./BarChartDisplay.scss?vue&type=style&index=0&id=39e285f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e285f1",
  null
  
)

export default component.exports